import * as React from 'react';

import { HeaderLogoAndTel } from '../../../HeaderLogoAndTel';
import { Modal } from '../../../Modal';

import * as main from '../styles/main.module.scss';
import * as heroHeader from '../styles/hero.module.scss';
import {AccessLimited} from "../../../AccessLimited";

export const HeroHeader = ({ widget, accessLimited }) => {
  const [showModal, setShowModal] = React.useState(false);

  return (
    <section className={heroHeader.hero}>
      <div className={'container'}>
        <div className={heroHeader.hero__wrapper}>
          <div className={heroHeader.hero__presentation}>
            <HeaderLogoAndTel />
            <h2 className={heroHeader.hero__subtitle}>Онлайн-курс</h2>
            <h1 className={heroHeader.hero__title}>
              «Английская грамматика
              <br />
              для детей»
            </h1>
            <ul className={heroHeader.hero__list}>
              <li
                className={`${heroHeader.hero__element} ${heroHeader.hero__elementOne} ${heroHeader.hero__text} ${heroHeader.hero__textSmall}`}
              >
                Для учеников
                <br /> 5–7-х классов
              </li>
              <li
                className={`${heroHeader.hero__element} ${heroHeader.hero__elementTwo} ${heroHeader.hero__text} ${heroHeader.hero__textSmall}`}
              >
                Для тех, кто хочет <br />
                учиться хорошо и&nbsp;ещё лучше
              </li>
            </ul>
            <div className={heroHeader.hero__button}>
              <button
                className={main.mainBtn}
                onClick={() => {
                  setShowModal(true);
                }}
              >
                Зарегистрироваться
              </button>
            </div>
            <p className={heroHeader.hero__text}>
              Поможем легко и быстро выучить <br />
              правила английской грамматики!
            </p>
            { accessLimited && <AccessLimited font={"12px"} className={heroHeader.hero__text}/> }
          </div>
        </div>
      </div>
      <Modal
        open={showModal}
        onClose={() => {
          setShowModal(false);
        }}
      >
        {widget}
      </Modal>
    </section>
  );
};
